import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { User } from '@/entities/layout';

import { MenuTrigger } from './menu-trigger';
import { MenuContent } from './menu-content';

interface SidebarFooterProps {
  user?: User;
  isCollapsed: boolean;
  isMobile: boolean;
}

export const SidebarFooter = ({ user, isCollapsed, isMobile }: SidebarFooterProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <MenuTrigger user={user} isCollapsed={isCollapsed} />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56 mb-1" side={isMobile ? 'top' : 'right'}>
        <MenuContent />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
